import { LoadingComponent } from './../common/loading/loading.component';
import { VoiceLoadingComponent } from '../common/chat/voice-loading/voice-loading.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NbActionsModule,
  NbCardModule,
  NbContextMenuModule,
  NbIconModule,
  NbInputModule,
  NbSelectModule,
  NbUserModule,
  NbTabsetModule,
  NbFormFieldModule,
  NbButtonModule,
  NbCheckboxModule,
  NbRouteTabsetModule,
  NbToggleModule,
  NbTagModule,
  NbTooltipModule,
  NbToastrModule,
  NbStepperModule,
  NbAccordionModule,
  NbDialogModule,
  NbLayoutModule,
  NbButtonGroupModule,
  NbChatModule,
  NbRadioModule,
  NbBadgeModule,
  NbAutocompleteModule,
  NbDatepickerModule,
  NbDateService,
  NbProgressBarModule,
} from '@nebular/theme';
// import { config } from "process";
import { CoreModule } from '../core/core.module';
import { StrongFBModule } from '../StrongFB/StrongFB.module';
import { DateAgoPipe } from './date-ago.pipe';
import { ShowUploadedFilesComponent } from './show-uploaded-files/show-uploaded-files.component';
import { JalaliDatePipe } from './jalali-date.pipe';
import { PaginationComponent } from '../common/pagination/pagination.component';
import { NotFoundComponent } from '../common/not-found/not-found.component';
import { ChatComponent } from '../common/chat/chat.component';
import { UploaderComponent } from '../common/chat/uploader/uploader.component';
import { PersonFormComponent } from '../modules/petition-builder/person-form/person-form.component';
import { DateFormComponent } from '../modules/petition-builder/date-form/date-form.component';
// import { NgxStarRatingModule } from 'ngx-star-rating';

import { BreadcrumbComponent } from '../common/breadcrumb/breadcrumb.component';
import { ConsultationDetailComponent } from '../common/consultation-detail/consultation-detail.component';
import { TimeRangePickerComponent } from './time-range-picker/time-range-picker.component';
import { TicketComponent } from '../common/ticket/ticket.component';
import { StrongFBDatepickerComponent } from './strong-fb-datepicker/strong-fb-datepicker.component';
import { NebularJalaliMomentService } from '../StrongFB/services/nebular-jalali-moment.service';
import { DatepickerComponent } from '../common/date-picker/date-picker.component';
import { ContractDetailComponent } from '../common/contract-detail/contract-detail.component';
import { ConsultationCreatorComponent } from '../common/consultation-creator/consultation-creator.component';
import { StarRatingComponent } from '../common/consultation-detail/star-rating/star-rating.component';
import { ConsultationKindsComponent } from './consultation-kinds/consultation-kinds.component';
import { SuggestionLawyerTimepickerComponent } from './suggestion-lawyer-timepicker/suggestion-lawyer-timepicker.component';
import { ComplaintDetailComponent } from '../common/complaint-detail/complaint-detail.component';
import { PetitionDetailComponent } from '../common/petition-detail/petition-detail.component';
import { JuducialDetailComponent } from '../common/juducial-detail/juducial-detail.component';
import { CommentsDetailsComponent } from '../common/comments-details/comments-details.component';
import { FlowChartBuilderComponent, LisencePlateConvertor } from '../common/flow-chart-builder/flow-chart-builder.component';
import { DictionaryComponent } from '../common/dictionary/dictionary/dictionary.component';
import { VjsPlayerComponent } from '../modules/education-user/vjs-player/vjs-player.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SetDateAndTimeComponent } from './set-date-and-time/set-date-and-time.component';
import { ConsultationInformationComponent } from './consultation-information/consultation-information.component';
import { LawyerListComponent } from './lawyer-list/lawyer-list.component';

@NgModule({
  declarations: [
    DateAgoPipe,
    ShowUploadedFilesComponent,
    NotFoundComponent,
    PaginationComponent,
    JalaliDatePipe,
    ChatComponent,
    UploaderComponent,
    LoadingComponent,
    VoiceLoadingComponent,
    PersonFormComponent,
    DateFormComponent,
    BreadcrumbComponent,
    ConsultationDetailComponent,
    TimeRangePickerComponent,
    TicketComponent,
    StrongFBDatepickerComponent,
    DatepickerComponent,
    ContractDetailComponent,
    PetitionDetailComponent,
    ComplaintDetailComponent,
    JuducialDetailComponent,
    StarRatingComponent,
    ConsultationCreatorComponent,
    ConsultationKindsComponent,
    SuggestionLawyerTimepickerComponent,
    CommentsDetailsComponent,
    FlowChartBuilderComponent,
    LisencePlateConvertor,
    DictionaryComponent,
    VjsPlayerComponent,
    SetDateAndTimeComponent,
    ConsultationInformationComponent,
    LawyerListComponent
  ],
  imports: [
    // NgxStarRatingModule,
    CoreModule,
    CommonModule,
    NbIconModule,
    NbSelectModule,
    NbActionsModule,
    NbUserModule,
    NbContextMenuModule,
    NbInputModule,
    NbCardModule,
    NbTabsetModule,
    NbFormFieldModule,
    NbButtonModule,
    FormsModule,
    NbCheckboxModule,
    HttpClientModule,
    NbRouteTabsetModule,
    ReactiveFormsModule,
    NbToggleModule,
    NbTagModule,
    NbTooltipModule,
    NbToastrModule,
    NbStepperModule,
    NbAccordionModule,
    StrongFBModule,
    NbDialogModule,
    NbChatModule,
    NbLayoutModule,
    NbButtonGroupModule,
    NbDialogModule.forChild(),
    NbDatepickerModule.forRoot(),
    NbRadioModule,
    NbBadgeModule,
    NbAutocompleteModule,
    NbProgressBarModule,
    NbAutocompleteModule,
    SafeHtmlPipe
  ],
  providers: [
    { provide: NbDateService, useExisting: NebularJalaliMomentService },
  ],
  exports: [
    CoreModule,
    CommonModule,
    NbIconModule,
    NbSelectModule,
    NbActionsModule,
    NbUserModule,
    NbContextMenuModule,
    NbInputModule,
    NbCardModule,
    NbTabsetModule,
    NbFormFieldModule,
    NbButtonModule,
    FormsModule,
    NbCheckboxModule,
    HttpClientModule,
    NbRouteTabsetModule,
    DateAgoPipe,
    ReactiveFormsModule,
    NbToggleModule,
    NbTagModule,
    NbTooltipModule,
    NbToastrModule,
    NbStepperModule,
    NbAccordionModule,
    StrongFBModule,
    NbDialogModule,
    ShowUploadedFilesComponent,
    JalaliDatePipe,
    NbChatModule,
    NotFoundComponent,
    PaginationComponent,
    ChatComponent,
    UploaderComponent,
    LoadingComponent,
    VoiceLoadingComponent,
    PersonFormComponent,
    DateFormComponent,
    NbProgressBarModule,
    NbRadioModule,
    NbBadgeModule,
    BreadcrumbComponent,
    ConsultationDetailComponent,
    DatepickerComponent,
    TimeRangePickerComponent,
    TicketComponent,
    NbDatepickerModule,
    StrongFBDatepickerComponent,
    ContractDetailComponent,
    PetitionDetailComponent,
    ConsultationCreatorComponent,
    StarRatingComponent,
    ConsultationKindsComponent,
    SuggestionLawyerTimepickerComponent,
    NbAutocompleteModule,
    ComplaintDetailComponent,
    JuducialDetailComponent,
    CommentsDetailsComponent,
    FlowChartBuilderComponent,
    LisencePlateConvertor,
    DictionaryComponent,
    VjsPlayerComponent,
    SafeHtmlPipe,
    SetDateAndTimeComponent,
    ConsultationInformationComponent,
    LawyerListComponent
  ],
})
export class SharedModule { }
